import classNames from 'classnames';
import styles from './FJSideModel.module.less';
import { useRef, forwardRef, useImperativeHandle } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { useState } from 'react';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';
import FJEvent from '../../../store/FJEvent.js';
import FJAnchor from '../FJDropDown/FJAnchor.jsx';

const FJSideModel = forwardRef((props, ref) => {
    const { children, active, onClose, className, position, absolutePosition = false } = props;

    const sideModelRef = useRef(null);
    const [statePosition, setStatePosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
        active && (window.closeSideModel = onClose);
    }, [onClose, active]);

    const handleOutsideClick = useCallback(
        e => {
            if (!sideModelRef.current.contains(e.target)) {
                onClose();
            }
        },
        [onClose],
    );

    const resizeFit = useCallback(() => {
        if (active && sideModelRef.current) {
            const rect = sideModelRef.current.getBoundingClientRect();
            const bodyHeight = document.documentElement.clientHeight;

            if (rect.height + position.top + 30 > bodyHeight && !absolutePosition) {
                setStatePosition({ top: bodyHeight - rect.height - 30, left: position.left });
            } else {
                setStatePosition({ top: position.top, left: position.left });
            }
        } else {
            setStatePosition({ top: position.top, left: position.left });
        }
    }, [active]);

    // 暴露 resizeFit 方法给父组件
    useImperativeHandle(ref, () => ({
        resizeFit,
    }));

    useEffect(() => {
        resizeFit();
    }, [resizeFit, position]);

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [handleOutsideClick]);

    useEffect(() => {
        if (active) {
            resizeFit();
            window.addEventListener('resize', resizeFit);
        } else {
            window.removeEventListener('resize', resizeFit);
        }
    }, [resizeFit, active]);

    useEffect(() => {
        FJEvent.subscribe(FJ_EVENT_TYPE.HIDE_SIDE_MODAL, () => {
            onClose();
        });
    }, []);
    if (absolutePosition) {
        return (
            <FJAnchor zIndex={4}>
                <div
                    className={classNames(styles.side_model_bpx, { [styles.active]: active }, className)}
                    style={{ top: statePosition.top, left: statePosition.left, position: 'absolute' }}
                    ref={sideModelRef}
                >
                    {children}
                </div>
            </FJAnchor>
        );
    }

    return (
        <div
            className={classNames(styles.side_model_bpx, { [styles.active]: active }, className)}
            style={{ top: statePosition.top, left: statePosition.left }}
            ref={sideModelRef}
        >
            {children}
        </div>
    );
});

export default FJSideModel;
